import { GuidT, SelectIF } from '@/types/common';
import { CategoryIF, PropertyBaseIF } from '@/api/propertyApi/types';

export const transformCategoriesToSelect = (
    backValues?: CategoryIF[],
): SelectIF<GuidT>[] | null => {
    if (!backValues?.length) {
        return null;
    }

    return backValues.map(({ name, guid, parentCategoryGuid, attributes }) => ({
        label: name,
        value: guid,
        settings: {
            parentId: parentCategoryGuid,
            attributes,
        },
    }));
};

export const transformToSelect = (
    backValues?: PropertyBaseIF[],
): SelectIF<GuidT>[] | null => {
    if (!backValues?.length) {
        return null;
    }

    return backValues.map(({ hex, name, guid, parentCategoryGuid }) => ({
        label: name,
        value: guid,
        settings: {
            hex,
            parentId: parentCategoryGuid,
        },
    }));
};

export const getLabelFromProperties = (
    propertiesData?: SelectIF[] | null,
    searchedValue?: string,
    defaultValue: string = '',
): string => {
    if (!searchedValue || !propertiesData?.length) {
        return defaultValue;
    }

    return (
        propertiesData.find(({ value }) => value === searchedValue)?.label ??
        defaultValue
    );
};
